import script from "./RouteProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./RouteProgressBar.vue?vue&type=style&index=0&id=35a2c48b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a2c48b"]])

export default __exports__